import React from "react";
import "../CompoundSlider.scss";
import PropTypes from "prop-types";

export class Track extends React.Component {
  static propTypes = {
    getTrackProps: PropTypes.func,
    target: PropTypes.shape({
      percent: PropTypes.number,
    }),
    source: PropTypes.shape({
      percent: PropTypes.number,
    }),
  };

  render() {
    const { getTrackProps, source, target } = this.props;
    return (
      <div
        className="trackStyle"
        style={{
          left: `${source.percent}%`,
          width: `${target.percent - source.percent}%`,
        }}
        {...getTrackProps()}
      />
    );
  }
}

export default Track;
